import FormControlLabel from "@material-ui/core/FormControlLabel";
import MUICheckbox from "@material-ui/core/Checkbox";
import React, { FC } from "react";
import { withStyles } from "@material-ui/core/styles";

import classes from "./CheckboxButtonOption.module.scss";

type CheckboxButtonOptionProps = {
  label: string;
  checked: boolean;
  name: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const Checkbox = withStyles({
  root: {
    "&$checked": {
      color: "#FF7A59",
    },
  },
  checked: {},
})((props: any) => <MUICheckbox color="default" {...props} />);

const CheckboxButtonOption: FC<CheckboxButtonOptionProps> = ({ label, checked, name, handleChange }) => {
  return (
    <FormControlLabel
      className={classes.checkboxButtonOption}
      control={<Checkbox checked={checked} name={name} onChange={handleChange} className={classes.checkbox} />}
      label={label}
    />
  );
};

export default CheckboxButtonOption;
